import React, { useEffect, useState } from 'react';
import { i18nFn, useAuthPin, useRequestPin } from '@springbig/shared';
import { useGeneralStyles } from '~/shared/styles';
import { useAppNavigate } from '~/pages';
import { useLocation } from 'react-router';
import { AuthTemplate } from '~/pages/auth/AuthTemplate';
import LoginTemplate from '~/pages/auth/LoginTemplate';

type LoginStepProps = {
    t: i18nFn;
    onEvent: (message: string) => void;
};

export const LoginStep = ({
    t,
    onEvent,
}: LoginStepProps) => {

    const [disabled, setDisabled] = useState(false);
    const { params } = useAppNavigate();
    const gStyle = useGeneralStyles();
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [countdown, setCountdown] = useState<number>(0);
  
    useEffect(() => {
      let timer;
      if (countdown > 0) {
        timer = setInterval(() => {
          setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);
      } else {
        setDisabled(false);
        clearInterval(timer);
      }
  
      return () => clearInterval(timer);
    }, [countdown]);

    useEffect(() => {
        let timer;

        if (disabled) {
            timer = setTimeout(() => {
                setDisabled(false);
            }, 60 * 1000);

            return () => clearTimeout(timer);
        }
    }, [disabled]);

    const codeLength = 4;

    const { mutate: authPin, error } = useAuthPin();

    const onSubmitCode = (data: {pin: string}): void => {

        authPin({
            pin: btoa(data.pin),
            stashboardOrMemberKey: params.wallet_id,
            reference: 'member'
        }, {
            onSuccess: (_) => {

                onEvent('welcome');
            }
        });
    };

    const { mutate: requestPin } = useRequestPin();

    const [isResendCode, setIsResendCode] = useState(false);

    const handleResendCode = () => {

        requestPin({
            stashboardOrMemberKey: params.wallet_id,
            reference: 'member',
            pin_length: 4,
        }, {
            onSuccess(data) {
                if (data) {
                    setPhoneNumber(data.phone);
                }
            },
        });
        setDisabled(true);
        setCountdown(30);
        setIsResendCode(true);
    };
    
    return <AuthTemplate 
      body={
        <LoginTemplate 
          codeLength={codeLength} 
          handleSubmit={onSubmitCode} 
          pinError={error?.data?.error} 
          disabled={disabled}
          phoneNumber={phoneNumber} 
          countdown={countdown} 
          handleResendCode={() => handleResendCode()}
          isResendCode={isResendCode}
        />
      } 
    />;
};
